import React from "react";
import ZCollapse from "@atoms/ZCollapse";
import { IEmailThread } from "./interface";
import ZEmailThreadMessageHeader from "./ZEmailThreadMessageHeader";
import ReactShadow from "react-shadow";
import "./index.less";
import ZEmailThreadMessageAttachment from "./ZEmailThreadAttachment";

const ZEmailThread: React.FC<IEmailThread> = ({ threads }) => {
	const panels = threads.map(thread => ({
		key: thread.id,
		showArrow: false,
		header: thread.from && (
			<ZEmailThreadMessageHeader
				from={thread.from}
				to={thread.to}
				cc={thread.cc}
				bcc={thread.bcc}
				replyTo={thread.replyTo}
				date={thread.date}
				subject={thread.subject}
				snippet={thread.snippet}
				files={thread.files}
				onReply={thread.onReply}
				isOthersEmailThread={thread.isOthersEmailThread}
			/>
		),
		className: "email-thread-message-collapse-item",
		render: (
			<div
				className="email-thread-message-body"
				id={`email-thread-message-body-${thread.id}`}
			>
				<ReactShadow.div>
					<div
						dangerouslySetInnerHTML={{
							__html: thread.body
						}}
					></div>
				</ReactShadow.div>
				<ZEmailThreadMessageAttachment
					files={thread.files}
					onDownload={file => thread.onDownload?.(file, thread.id)}
				/>
			</div>
		)
	}));
	return (
		<div className="email-thread-container">
			{!!threads.length && (
				<ZCollapse
					bordered={false}
					defaultActiveKey={threads[0].id}
					destroyInactivePanel={false}
					accordion
					panels={panels}
					collapsible={panels.length > 1 ? "header" : "disabled"}
					className="drawer-form-container email-thread-message-collapse pb-0"
				/>
			)}
		</div>
	);
};

export default ZEmailThread;
